module.exports = __webpack_public_path__ + "img/06.8640cfd3.jpg";